<template>
  <v-dialog
    v-model="dialog"
    width="916"
    open-on-focus
    no-click-animation
    persistent
    content-class="sequence-preview-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-toolbar
        flat
        height="76"
      >
        <v-toolbar-title class="sequence-preview-toolbar-title">Preview Routine {{sequence.title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          icon
          tile
          @click="closeDialog"
        >
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="sequence">
        <sequence-exercises-container 
          :days="days"
          :hideMenu="true"
          :readonly="true"
          />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import SequenceExercisesContainer from "@/components/exercises/SequenceExercisesContainer.vue"

export default {
  name: 'SequencePreviewDialog',
  components: {
    SequenceExercisesContainer
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    sequence: {
      type: Object,
      default: function(){ return {}}
    }
  },
  data () {
    return {
      dialog: false,
      days: []
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
        setTimeout(()=>{
          this.days = this.sequenceDefinition.days
        },100)
      } else {
        this.dialog = false
        this.days = []
      }
    }
  },
  computed: {
    ...mapState('userStates', [
      'profileId'
    ]),
    ...mapState('exercisesStates', [
      'sequenceDefinition'
    ]),
  },
  created() {
  },
  methods: {
    closeDialog () {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.sequence-preview {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2*$gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
    }
    .sequence {
      background:$bh-white;
      padding: 0;
      height: calc(100% - 76px);
      overflow: auto;
      .sequence-exercises-container {
        padding-top: 15px;
        height: calc(100vh - 107px);
      }
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-gray--2;
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-container {
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-footer {
      padding: 1.5*$gutter;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5*$gutter;
        padding-right: 1.5*$gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25*$gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25*$gutter
    }
  }
}
</style>
